<template>
	<div class="no-data">
		<img v-if="mode === 'image'" src="~@/assets/img/search/no-search-img.png" class="no-data__img" />
		<p class="no-data__text">{{text}}</p>
	</div>
</template>

<script>
	export default {
		props: {
			mode: {
				type: String,
				default: 'text'
			},
			text: {
				type: String,
				default: '— 我的有底线的 —'
			}
		}
	}
</script>

<style lang="scss">
	.no-data{
		padding: 100px 0;
		.no-data__img{
			width: 346px;
			margin: 0 auto;
			display: block;
		}
		.no-data__text{
			text-align: center;
			font-size: 18px;
			font-weight: 400;
			color: #666666;
			line-height: 58px;
			margin-top: 20px;
		}
	}
</style>
